import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import getGoodiesInCodebase from '../../../selectors/getGoodiesInCodebase';
import GoodyItem from './GoodyItem';

class GoodyList extends React.Component {
	constructor() {
		super();

		this.state = {
			newGoodies: [],
		};
	}

	componentDidMount() {
		this.setNewGoodies(this.props.newGoodies);
	}

	componentWillReceiveProps(nextProps) {
		// If new goodies have been added since mounting, add them to the state.
		// This happens when you buy a pet and receive a new goody.
		if (!_.isEmpty(nextProps.newGoodies)) {
			this.setNewGoodies(nextProps.newGoodies);
		}

		// When the bag was open and then gets closed, clear our state to reflect the updated redux store.
		if (this.props.isOpen && !nextProps.isOpen && !_.isEmpty(this.state.newGoodies)) {
			this.setNewGoodies(); // clear new goodies
		}
	}

	setNewGoodies(newGoodies) {
		// Save the new goodies to state, so that when they're cleared by the GoodyBag we still can show what's new.
		this.setState({ newGoodies });
	}

	render() {
		return (
			<div className="goodies__list">
				{this.props.collectedGoodies.map(goody => (
					<GoodyItem
						key={goody.id}
						type={goody.type}
						name={goody.name}
						id={goody.id}
						isActive={this.props.activeGoodies[goody.type] === goody.id}
						isNew={_.includes(this.state.newGoodies, goody.id)}
					/>
				))}
			</div>
		);
	}
}

GoodyList.PropTypes = {
	collectedGoodies: PropTypes.arrayOf(
		PropTypes.shape({
			type: PropTypes.string,
			name: PropTypes.string,
		}),
	).isRequired,
	newGoodies: PropTypes.arrayOf(PropTypes.string).isRequired,
	activeGoodies: PropTypes.shape({
		hat: PropTypes.string,
		glasses: PropTypes.string,
		toy: PropTypes.toy,
	}),
	isOpen: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
	collectedGoodies: getGoodiesInCodebase(state.collectedGoodies.list),
	newGoodies: state.collectedGoodies.newItems,
	activeGoodies: state.activeGoodies.active,
});

export default connect(mapStateToProps)(GoodyList);



// WEBPACK FOOTER //
// ./src/components/Extension/GoodyBag/GoodyList.js